import styled from "styled-components";
import { useT } from "@sablier/v2-locales";
import { Card as Base } from "~/client/components";
import Fields from "../fields";

const WrapperPartial = styled(Base)`
  width: 100%;
`;

const Grid = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: ${(props) => props.theme.sizes.formEdge};
  width: 100%;
  padding-top: calc(${(props) => props.theme.sizes.formEdge} * 1);

  & > * {
    grid-column: span 2;
    &:nth-child(1),
    &:nth-child(2) {
      grid-column: span 1;
    }
  }
`;

const Wrapper = styled(WrapperPartial)`
  ${(props) => props.theme.medias.maxXL} {
    width: 100%;
    ${Grid} {
      grid-template-columns: 1fr;
      row-gap: calc(${(props) => props.theme.sizes.edge} * 1);
      & > * {
        grid-column: span 1;
      }
    }
  }

  ${(props) => props.theme.medias.maxLG} {
    ${Grid} {
      grid-template-columns: 1fr 1fr;
      width: 100%;
    }
  }
  ${(props) => props.theme.medias.maxMD} {
    & > *[data-component="card"] {
      padding-inline: calc(${(props) => props.theme.sizes.edge} * 1 / 2);
      border-radius: 0;
    }
    ${Grid} {
      grid-template-columns: 1fr;
    }
  }
`;

interface Props {}

function General({}: Props) {
  const { t } = useT();
  return (
    <Wrapper title={t("structs.generalDetails")}>
      <Grid>
        <Fields.Shape />
        <Fields.Cancelability />
        <Fields.Token />
      </Grid>
    </Wrapper>
  );
}

export default General;
